import type { TraceDelivery, TraceDetailBatch, TracePointsBatch, TraceSink, TransportRequest, TransportResult } from '@krp/client-runtime'

import { AQSI_TRACE_URLS } from './urls'

/** Таймаут служебного запроса трассировки, мс: ждать её дольше, чем нужно, незачем. */
const TRACE_TIMEOUT_MS = 10_000

/** Как приёмник отправляет запрос: через transport стора мимо кэша RTK (`dispatch(transportRequest(...))`). */
export type TraceSend = (request: TransportRequest) => Promise<TransportResult<unknown>>

/**
 * Итог отправки для очереди трассировки: принято — `sent`; не дошло (сеть, неизвестный исход, 5xx, истёкшая сессия) — `retry`;
 * отказ по существу (нет права, не по договору) — `drop`: повтор того же пакета ответ не изменит.
 */
export function deliveryOf(result: TransportResult<unknown>): TraceDelivery {
  if (result.ok) return 'sent'
  const { kind } = result.error
  if (kind === 'network' || kind === 'timeout' || kind === 'unknown-outcome' || kind === 'unavailable' || kind === 'unauthorized') {
    return 'retry'
  }
  const status = result.error.status
  return status !== undefined && status >= 500 ? 'retry' : 'drop'
}

/**
 * Приёмник трассировки браузера для кабинета AQSI. `scope` пакета — идентификатор кабинета. Запросы фоновые (`background`):
 * их сбой не попадает в общий сигнал связи и не показывается кассиру.
 */
export function createAqsiTraceSink(send: TraceSend): TraceSink {
  const post = (url: string, body: unknown): Promise<TraceDelivery> =>
    send({ url, method: 'POST', body, background: true, timeoutMs: TRACE_TIMEOUT_MS }).then(deliveryOf)
  return {
    sendPoints: (batch: TracePointsBatch) =>
      post(AQSI_TRACE_URLS.browser(batch.scope), {
        saleId: batch.saleId,
        attemptKey: batch.attemptKey,
        points: batch.points,
        network: batch.network,
      }),
    sendDetail: (batch: TraceDetailBatch) =>
      post(AQSI_TRACE_URLS.browserDetail(batch.scope), { saleId: batch.saleId, events: batch.events }),
  }
}
